import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import React from 'react';
import { withStyles, createStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import PageSelector from './PageSelector';
import GridViewMode from '../Mode';
import ContainerDimension from './ContainerDimension';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import { compose } from 'redux';

var styles = function styles(theme) {
  return createStyles({
    root: {
      marginLeft: theme.spacing(2)
    },
    itemsPerPageSelectRoot: {
      marginRight: theme.spacing(1),
      marginLeft: theme.spacing(1)
    },
    itemsPerPageSelect: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(3),
      border: "1px solid ".concat(theme.palette.divider),
      minWidth: 32
    },
    itemsPerPageRoot: {
      whiteSpace: 'nowrap'
    }
  });
};

var formatCurrentPage = function formatCurrentPage(page, count, itemsPerPage) {
  var from = count === 0 ? 0 : page * itemsPerPage + 1;
  var to = Math.min(count, (page + 1) * itemsPerPage);
  return "".concat(from, " - ").concat(to, " of ").concat(count);
};
/**
 * @param {import('./types').DataGridViewPaginationProps & import('@material-ui/core').WithStyles<typeof styles> } props
 */


var DataGridViewPagination = function DataGridViewPagination(_ref) {
  var classes = _ref.classes,
      count = _ref.count,
      page = _ref.page,
      itemsPerPage = _ref.itemsPerPage,
      mode = _ref.mode,
      hidePageSelector = _ref.hidePageSelector,
      hideItemsPerPage = _ref.hideItemsPerPage,
      hideModeSwitcher = _ref.hideModeSwitcher,
      pageSizes = _ref.pageSizes,
      itemsPerPageLabel = _ref.itemsPerPageLabel,
      onChangeMode = _ref.onChangeMode,
      onChangePage = _ref.onChangePage,
      onChangeItemsPerPage = _ref.onChangeItemsPerPage,
      paginationStyle = _ref.paginationStyle,
      width = _ref.width,
      indent = _ref.indent;
  React.useEffect(function () {
    var newLastPage = Math.max(0, Math.ceil(count / itemsPerPage) - 1);
    if (onChangePage && page > newLastPage) onChangePage(null, newLastPage);
  }, [count, itemsPerPage]);
  var computedHidePageSelector = hidePageSelector || count <= itemsPerPage;
  var computedHideItemsPerPage = hideItemsPerPage || count <= 10;
  var hidePagination = computedHidePageSelector && computedHideItemsPerPage && hideModeSwitcher;
  if (hidePagination) return null;
  return React.createElement(Toolbar, {
    disableGutters: true,
    className: classes.root,
    style: _objectSpread({
      marginLeft: indent
    }, paginationStyle || {})
  }, React.createElement(Grid, {
    container: true,
    direction: "row",
    justify: "space-between",
    alignItems: "center"
  }, React.createElement(ContainerDimension, {
    width: width
  }, function (computedWidth) {
    var customContainerWidth;

    if (computedWidth) {
      if (computedWidth >= 1280) customContainerWidth = 'lg';else if (computedWidth >= 960) customContainerWidth = 'md';else if (computedWidth >= 600) customContainerWidth = 'sm';else if (computedWidth >= 0) customContainerWidth = 'xs';
    }

    return React.createElement(Grid, {
      item: true,
      xs: true
    }, React.createElement(Grid, {
      container: true,
      alignItems: "center",
      justify: "flex-start"
    }, !computedHidePageSelector && React.createElement(Grid, {
      item: true
    }, React.createElement(PageSelector, {
      parentWidth: customContainerWidth,
      page: page,
      count: count,
      itemsPerPage: itemsPerPage,
      onChangePage: onChangePage
    })), !computedHideItemsPerPage && React.createElement(Grid, {
      item: true
    }, React.createElement("div", {
      className: classes.itemsPerPageRoot
    }, pageSizes.length && computedWidth >= 599 && React.createElement(Typography, {
      display: "inline"
    }, itemsPerPageLabel), pageSizes.length && React.createElement(Select, {
      className: classes.itemsPerPageSelectRoot,
      disableUnderline: true,
      classes: {
        select: classes.itemsPerPageSelect
      },
      value: itemsPerPage,
      onChange: function onChange(e) {
        return onChangeItemsPerPage(e, Number(e.target.value));
      }
    }, pageSizes.map(function (pageSize) {
      return React.createElement(MenuItem, {
        key: pageSize,
        value: pageSize
      }, pageSize);
    })), isWidthUp('sm', customContainerWidth) && React.createElement(Typography, {
      display: "inline"
    }, formatCurrentPage(page, count, itemsPerPage))))));
  }), onChangeMode && mode && !hideModeSwitcher && React.createElement(Grid, {
    item: true
  }, React.createElement(GridViewMode, {
    onChange: onChangeMode,
    mode: mode
  }))));
};
/**@type {Partial<import('./types').DataGridViewPaginationProps>} */


DataGridViewPagination.defaultProps = {
  itemsPerPageLabel: 'Items Per Page',
  pageSizes: [10, 20, 50, 100, 200],
  count: 0,
  page: 0,
  itemsPerPage: 10,
  hidePageSelector: false,
  hideItemsPerPage: false,
  hideModeSwitcher: false
};
export default React.memo(compose(withStyles(styles, {
  name: 'ECDataGridViewPagination',
  withTheme: true
}), withWidth())(DataGridViewPagination));